import { render, staticRenderFns } from "./VDateRange.vue?vue&type=template&id=237cb5a6&"
import script from "./VDateRange.vue?vue&type=script&lang=js&"
export * from "./VDateRange.vue?vue&type=script&lang=js&"
import style0 from "./VDateRange.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports